/**
 * PHYSICAL-RISK-WIZARD.CONSTANTS
 * Etapes du wizard d'ajout / modification d'un risque. La vue d'ensemble n'en fait pas partie :
 * elle recapitule les etapes et se pilote par le mode "isWizardOverview" de la modale.
 * Declarees ici (et nulle part ailleurs) pour que la modale, qui les enchaine, et la vue d'ensemble,
 * qui les recapitule, partagent les memes ids et les memes libelles.
 */

export type WizardStep = "PERIMETER" | "DESCRIPTION" | "SEVERITY" | "FREQUENCY" | "PREVENTION" | "EVALUATION"

export const WIZARD_STEPS: Array<{ id: WizardStep; label: string; description: string }> = [
  { id: "PERIMETER", label: "Périmètre", description: "Unités de travail concernées" },
  { id: "DESCRIPTION", label: "Description", description: "Nature et circonstances" },
  { id: "SEVERITY", label: "Gravité", description: "Conséquences possibles" },
  { id: "FREQUENCY", label: "Fréquence", description: "Exposition au risque" },
  { id: "PREVENTION", label: "Prévention", description: "Mesures existantes" },
  { id: "EVALUATION", label: "Évaluation", description: "Niveau de prévention" }
]
